import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_10'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_10',
  name: 'Does the facility have any of the following safety measures in place related to forklifts (and other types of lifting equipment)?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FORK_LIFTS_ARE_INSPECTED_AND_MAINTAINED_ON_A_REGULAR_BASIS',
      text: 'Fork lifts are inspected and maintained on a regular basis',
      externalIds: [
        {
          id: 'hs-38--2-3x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FORKLIFT_TRUCKS_HAVE_WARNING_LIGHTS_AND_AUDIBLE_SIGNALS_FOR_REV',
      text: 'Forklift trucks have warning lights and audible signals for reverse travel',
      externalIds: [
        {
          id: 'hs-38--2-4x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_PROHIBITS_OVERLOADING_MATERIALS_ON_FORKLIFT_TRUCKS',
      text: 'Facility prohibits overloading materials on forklift trucks',
      externalIds: [
        {
          id: 'hs-38--2-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_PROHIBITS_USING_FORKLIFTS_TO_LIFT_WORKERS_SO_THAT_',
      text: 'The facility prohibits using forklifts to lift workers so that they can perform activities at higher heights',
      externalIds: [
        {
          id: 'hs-38--2-6x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'THE_FACILITY_PROHIBITS_LOCATING_BATTERY_CHARGING_AREAS_FOR_ELEC',
      text: 'The facility prohibits locating battery charging areas for electric forklift trucks close to storage areas of combustible materials',
      externalIds: [
        {
          id: 'hs-38--2-7x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FORKLIFT_ROUTES_ARE_CLEARLY_MARKED',
      text: 'Forklift routes are clearly marked',
      externalIds: [
        {
          id: 'hs-38--2-8x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FORKLIFTS_ARE_PARKED_IN_DESIGNATED_LOCATION_S_WHEN_NOT_IN_USE',
      text: 'Forklifts are parked in designated location(s) when not in use',
      externalIds: [
        {
          id: 'hs-38--2-9x',
          version: '1.3',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-38--2-10x',
          version: 1.3,
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FORK_LIFTS_ARE_INSPECTED_AND_MAINTAINED_ON_A_REGULAR_BASIS',
                'FORKLIFT_TRUCKS_HAVE_WARNING_LIGHTS_AND_AUDIBLE_SIGNALS_FOR_REV',
                'FACILITY_PROHIBITS_OVERLOADING_MATERIALS_ON_FORKLIFT_TRUCKS',
                'THE_FACILITY_PROHIBITS_USING_FORKLIFTS_TO_LIFT_WORKERS_SO_THAT_',
                'THE_FACILITY_PROHIBITS_LOCATING_BATTERY_CHARGING_AREAS_FOR_ELEC',
                'FORKLIFT_ROUTES_ARE_CLEARLY_MARKED',
                'FORKLIFTS_ARE_PARKED_IN_DESIGNATED_LOCATION_S_WHEN_NOT_IN_USE',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-mat-3',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16460,
  sectionId: '2.2.9.6',
  impactArea: 'Materials Handling and Storage',
  impactAreaId: 'MATERIALS_HANDLING_AND_STORAGE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
